(function () {
  const root = typeof window !== 'undefined' ? window : globalThis;

  function stringValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function clampRating(value) {
    const rating = Number(value);
    if (!Number.isFinite(rating)) return 0;
    return Math.max(0, Math.min(5, rating));
  }

  function starRating(value) {
    return Math.floor(clampRating(value));
  }

  function starText(value) {
    const rating = starRating(value);
    return '\u2605'.repeat(rating) + '\u2606'.repeat(5 - rating);
  }

  function abbreviatedName(value) {
    const parts = stringValue(value).split(/\s+/).filter(Boolean);

    if (parts.length > 1) {
      return parts[0] + ' ' + parts[parts.length - 1].charAt(0) + '.';
    }

    return parts[0] || '';
  }

  function isVerified(value) {
    return value === 1 || value === true || value === '1';
  }

  function isPublished(value) {
    if (value === undefined || value === null || value === '') return true;
    return value === 1 || value === true || value === '1';
  }

  function normalizeTags(attr) {
    const tags = [];

    if (!Array.isArray(attr)) return tags;

    attr.forEach(function (group) {
      const values = group && Array.isArray(group.values) ? group.values : [];

      values.forEach(function (value) {
        const tag = stringValue(value);
        if (tag) tags.push(tag);
      });
    });

    return tags;
  }

  function formatReviewDate(value) {
    const iso = stringValue(value);
    const dateParts = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (dateParts) {
      return dateParts[2] + '/' + dateParts[3] + '/' + dateParts[1];
    }

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return month + '/' + day + '/' + date.getFullYear();
  }

  function normalizeReview(raw) {
    const review = raw || {};
    const createdAtIso = stringValue(review.created_at_iso || review.created_at || review.date);
    const replyCreatedAtIso = stringValue(
      review.reply_created_at_iso || review.reply_created_at || review.reply_date
    );
    const rating = clampRating(review.rating);

    return {
      displayName: abbreviatedName(review.name || review.author),
      rating: rating,
      ratingLabelValue: stringValue(rating),
      starText: starText(rating),
      isVerified: isVerified(review.verified),
      title: stringValue(review.title || review.review_title),
      body: stringValue(review.body || review.review_body || review.content),
      tags: normalizeTags(review.attr),
      createdAtIso: createdAtIso,
      displayDate: formatReviewDate(createdAtIso),
      reply: stringValue(review.reply || review.merchant_reply || review.response),
      replyCreatedAtIso: replyCreatedAtIso,
      replyDisplayDate: formatReviewDate(replyCreatedAtIso)
    };
  }

  function normalizeResponse(payload) {
    const response = payload || {};
    let rawReviews = [];
    let nextCursor = '';

    if (Array.isArray(response.data)) {
      rawReviews = response.data;
    } else if (Array.isArray(response.reviews)) {
      rawReviews = response.reviews;
    } else if (Array.isArray(response.r)) {
      rawReviews = response.r;
    }

    if (Array.isArray(response.sa)) {
      nextCursor = response.sa.map(stringValue).filter(Boolean).join(',');
    } else {
      nextCursor = stringValue(response.sa || response.next_cursor || response.nextCursor);
    }

    return {
      reviews: rawReviews.filter(function (review) {
        return isPublished(review && review.published);
      }).map(normalizeReview),
      nextCursor: nextCursor
    };
  }

  function setText(card, selector, value) {
    const element = card.querySelector(selector);
    if (element) element.textContent = value;
  }

  function setOptionalText(card, selector, value) {
    const element = card.querySelector(selector);
    if (!element) return;

    element.textContent = value;
    element.hidden = !value;
  }

  function renderTags(container, tags) {
    container.replaceChildren();

    tags.forEach(function (tag) {
      const badge = document.createElement('span');
      badge.className = 'badge reviews-card__badge';
      badge.textContent = tag;
      container.appendChild(badge);
    });

    container.hidden = tags.length === 0;
  }

  function renderReviewCard(template, review, labels) {
    const card = template.content.firstElementChild.cloneNode(true);
    const verified = card.querySelector('[data-review-verified]');
    const tags = card.querySelector('[data-review-tags]');
    const meta = card.querySelector('[data-review-meta]');
    const date = card.querySelector('[data-review-date]');
    const reply = card.querySelector('[data-review-reply]');
    const replyLabel = card.querySelector('[data-review-reply-label]');
    const replyBody = card.querySelector('[data-review-reply-body]');
    const replyDate = card.querySelector('[data-review-reply-date]');

    setText(card, '[data-review-name]', review.displayName);
    setText(card, '[data-review-stars]', review.starText);
    setText(
      card,
      '[data-review-rating-label]',
      labels.rated.replace('[rating]', review.ratingLabelValue)
    );
    setOptionalText(card, '[data-review-title]', review.title);
    setOptionalText(card, '[data-review-body]', review.body);

    if (verified) {
      verified.hidden = !review.isVerified;
      setText(verified, '[data-review-verified-label]', labels.verified);
    }

    if (tags) renderTags(tags, review.tags);

    if (date) {
      date.textContent = review.displayDate;
      date.hidden = !review.displayDate;

      if (review.createdAtIso) {
        date.setAttribute('datetime', review.createdAtIso);
      } else {
        date.removeAttribute('datetime');
      }
    }

    if (meta) meta.hidden = review.tags.length === 0 && !review.displayDate;

    if (reply) {
      reply.hidden = !review.reply;
    }

    if (replyLabel) {
      replyLabel.textContent = labels.merchantReply || '';
    }

    if (replyBody) {
      replyBody.textContent = review.reply;
    }

    if (replyDate) {
      replyDate.textContent = review.replyDisplayDate;
      replyDate.hidden = !review.replyDisplayDate;

      if (review.replyCreatedAtIso) {
        replyDate.setAttribute('datetime', review.replyCreatedAtIso);
      } else {
        replyDate.removeAttribute('datetime');
      }
    }

    return card;
  }

  const testApi = {
    abbreviatedName: abbreviatedName,
    clampRating: clampRating,
    formatReviewDate: formatReviewDate,
    normalizeResponse: normalizeResponse,
    normalizeReview: normalizeReview,
    isPublished: isPublished,
    starText: starText
  };

  if (root && root.CK_REVIEW_LOAD_MORE_TEST_HOOKS) {
    root.CKReviewLoadMore = testApi;
  }

  if (typeof document === 'undefined') return;

  function initLoadMoreButton(btn) {
    if (btn.dataset.reviewsLoadMoreInitialized === 'true') return;
    btn.dataset.reviewsLoadMoreInitialized = 'true';

    const widget = btn.closest('[data-reviews-widget]') || btn.closest('.reviews-widget');
    const list = widget && widget.querySelector('.reviews-list');
    const template = widget && widget.querySelector('[data-reviews-card-template]');

    if (!list || !template || !template.content || !template.content.firstElementChild) return;

    let cursor = btn.dataset.cursor;
    let fails = 0;
    const labels = {
      verified: btn.dataset.labelVerified || '',
      rated: btn.dataset.labelRated || '[rating]',
      merchantReply: btn.dataset.labelMerchantReply || '',
      error: btn.dataset.labelError || ''
    };
    const baseUrl = 'https://apps.belkapp.com/api/reviews/client/'
      + encodeURIComponent(btn.dataset.shop) + '/by_entity_id/r/'
      + encodeURIComponent(btn.dataset.productId) + '/';

    btn.addEventListener('click', async function () {
      if (btn.disabled) return;
      btn.disabled = true;

      const ac = new AbortController();
      const timer = setTimeout(function () { ac.abort(); }, 8000);

      try {
        const url = cursor ? baseUrl + '?sa=' + encodeURIComponent(cursor) : baseUrl;
        const response = await fetch(url, { signal: ac.signal });
        if (!response.ok) throw response;

        const json = await response.json();
        const normalized = normalizeResponse(json);

        fails = 0;

        if (normalized.reviews.length > 0) {
          const fragment = document.createDocumentFragment();

          normalized.reviews.forEach(function (review) {
            fragment.appendChild(renderReviewCard(template, review, labels));
          });

          list.appendChild(fragment);
        }

        if (normalized.nextCursor) {
          cursor = normalized.nextCursor;
          btn.disabled = false;
        } else {
          btn.parentElement.remove();
        }
      } catch {
        if (++fails >= 3) {
          btn.textContent = labels.error;
          btn.disabled = true;
        } else {
          btn.disabled = false;
        }
      } finally {
        clearTimeout(timer);
      }
    });
  }

  function initLoadMoreButtons(root) {
    root.querySelectorAll('[data-reviews-load-more]').forEach(initLoadMoreButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLoadMoreButtons(document);
    });
  } else {
    initLoadMoreButtons(document);
  }

  if (root.Shopify && root.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initLoadMoreButtons(event.target);
    });
  }
})();
